'use client'

import styled from "styled-components";

import {getSizeStyles} from "@/components/UI/Title/options/size.options";
import {getColorStyles} from "@/components/UI/Title/options/color.options";


export const TitleStyled = styled.h1`
    ${getColorStyles}
    ${getSizeStyles}
`;
